import { render, staticRenderFns } from "./topDrivers.vue?vue&type=template&id=f1a19872&"
import script from "./topDrivers.vue?vue&type=script&lang=js&"
export * from "./topDrivers.vue?vue&type=script&lang=js&"
import style0 from "./topDrivers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports